export default __webpack_public_path__ + "static/media/10.835abe75.jpg";